import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { auth, logout, getData } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import { CHECKLSIT, CHECKLSIT_START} from "../../constants/checkList"
import { IMAGES } from "../../constants/index"
import { CAMPAIGN_DATE } from "../../constants/constants"


import './NotePage.css';


function NotePage(){
    let navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [opacity, setOpacity] = useState(0);
    const [data,setData] = useState(null)
    const [checkList,setCheckList] = useState(null)
    

    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData()
        }
    }, [user]);
    useEffect(()=>{
        if(data){
            setTimeout(() => {
                setOpacity(1);
            }, 500); // 0.5초 후 페이드 인
        }
    },[data])

    const getUserData = async () => {
        const data = await getData(user.uid)
        setData(data[0])
        setCheckList(data[0].checkList)
    }
    const handleNavigation = (address) => {
        setOpacity(0); // 🔥 페이드 아웃 시작
        setTimeout(() => {
            navigate(address);
        }, 2000);
    }
    const handleBack = () => {
        setOpacity(0);
        setTimeout(() => {
            navigate('/myFaith');
        }, 2000);
    }
    const handlelogout = async() => {
        const isConfirmed = window.confirm("로그아웃 하시겠습니까?");
        if (isConfirmed) {
            try{
                const result = await logout()
                navigate('/login');
            } catch (e) {
                console.error("로그아웃에 실패했습니다.", e)
            }
        }
    }


    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="noteWrap" style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <div className="contentsTitle">
                    {/* <span className="iconButton"> */}
                    <span className="iconButton" onClick={handleBack}>
                        <FontAwesomeIcon className="iconBtn" icon={faArrowLeft} style={{color:"#131835"}}/>
                    </span>
                    <span style={{textAlign:'center'}}>
                        <span style={{display:'block', marginBottom:'10px'}}>믿음의 여정</span>
                        <span style={{display:'block',fontSize:'12px',textAlign:'center', opacity:0.5,fontFamily:'GapyeongHanseokbongL'}}>#{data?.id}</span>
                    </span>
                    <span className="iconButton">
                    </span>
                </div>
                <div className="contents">
                {checkList&&Object.entries(checkList)
                .sort(([a], [b]) => parseInt(a.replace("Day.", ""), 10) - parseInt(b.replace("Day.", ""), 10)) // ✅ "Day.n"을 숫자로 변환하여 정렬
                .map(([key, values]) => {
                    if (!Array.isArray(values)) return null; // ✅ 값이 배열이 아니면 무시
                    const lastItem = values[values.length - 1]; // ✅ 마지막 값 가져오기
                    return (
                        typeof lastItem === "string" && ( // ✅ 마지막 값이 문자열인지 확인
                            <div key={key} style={{display:'block',marginBottom:'50px'}}>
                                <span style={{display:'block',fontFamily:'Somi',fontSize:'20px'}}>{key}</span>
                                <pre style={{display:'block',fontFamily:'GapyeongHanseokbongL', padding:'15px',background:'rgba(255,255,255,0.2)',borderRadius:'10px', wordBreak:'break-word',whiteSpace:'pre-wrap'}}>{lastItem}</pre>
                            </div>
                        )
                    );
                })}
                </div>
                <div className="contentsButton">
                </div>  
            </div>
        </div>
    );
  }
  export default NotePage;